export const MAX_KIDS_LIST = 20

export const KIDS_TABLET_MAX_WIDTH = "1023px"
